import accountSlice from "../slices/accountSlice";
import { contractApi } from "../services/contractApi";

export const accountReducers = {
  account: accountSlice,
};

export const contractReducers = {
  [contractApi.reducerPath]: contractApi.reducer,
  contract: contractApi,
};
